import axios from 'axios';
import { useToast } from 'vue-toastification';

const toast = useToast();

const state = {
    proceedings: null,
    proceeding: null
    };

const getters = {
    stateProceedings: state => state.proceedings,
    stateProceeding: state => state.proceeding,
};

const actions = {
    async createProceeding({commit}, proceeding) {
        try {
            console.log(proceeding);
            // Define the data structure to be sent
            const proceedingData = {
              number: proceeding.number,
              description: proceeding.description,
              user_id: proceeding.user_id,
              // Add any other necessary fields here
            };
            let {data} = await axios.post('proceedings/add', proceedingData);
            toast.success('Expediente creado');
            commit('setProceeding', data);
          } catch (error) {
            console.error('Error creating proceeding:', error);
            toast.error('Error al crear el expediente');
          }
    },
    async getProceedings({commit}, user) {
        let {data} = await axios.get(`proceedings/get_by_user/${user.id}`);
        commit('setProceedings', data);
    },
    async viewProceeding({commit}, id) {
        let {data} = await axios.get(`proceedings/get/${id}`);
        commit('setProceeding', data);
    },
    // eslint-disable-next-line no-empty-pattern
    async updateProceeding({}, proceeding) {
        await axios.patch(`proceedings/update/${proceeding.id}`, proceeding.form);
    },
    // eslint-disable-next-line no-empty-pattern
    async deleteProceeding({}, id) {
        await axios.delete(`proceedings/delete/${id}`);
    },
    // eslint-disable-next-line no-empty-pattern
    async searchProceeding({}, payload) {
        let {data} = await axios.post(`search_in_journal`, payload);
        //console.log(data);
        if(data.status_code === 404){
            toast.error(data.error);
            return null;
        }
        if(data.status_code === 200){
            toast.success('Expediente encontrado en el diario oficial');
            return data;
        }
        return data;
    }
    
};

const mutations = {
    setProceedings(state, proceedings){
        state.proceedings = proceedings;
    },
    setProceeding(state, proceeding){
        state.proceeding = proceeding;
    },
};

export default {
    state,
    getters,
    actions,
    mutations
};